import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from '../../../app/config';

export const apiBaseUrl = config.api.backend.url;

export const baseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  credentials: 'include',
});
